import { render, staticRenderFns } from "./trucks.html?vue&type=template&id=f2379900&scoped=true&"
import script from "./trucks.ts?vue&type=script&lang=js&"
export * from "./trucks.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2379900",
  null
  
)

export default component.exports